<template>
    <div class="login">
        <div class="login_main">
            <div class="login_plane">
                <div class="plane">
                    <div class="plane_1">
                        <!-- 标题 -->
                        <div class="title">
                            <!-- 大标题 -->
                            <div class="title_1">VPNS</div>
                            <!-- 小标题 -->
                            <div class="title_2">{{ $t('login.tip') }}</div>
                        </div>
                        <!-- 输入框1 -->
                        <div class="input">
                            <el-input v-model="login.email" :placeholder="$t('login.email')" />
                        </div>
                        <!-- 输入框2 -->
                        <div class="input">
                            <el-input v-model="login.pass" type="password" show-password
                                :placeholder="$t('login.password')" />
                        </div>
                        <!-- 图片验证码 -->
                        <div class="input">
                            <div class="felx">
                                <div class="flex-3"><el-input v-model="login.code"
                                        :placeholder="$t('login.verification_code')" /></div>
                                <div class="flex-1"></div>
                                <div class="flex-2" @click="changeCode()"> <img :src="codeImg" alt=""></div>

                            </div>
                        </div>
                        <!-- 登录按钮 -->
                        <div class="but_1">
                            <el-button type="primary" style="width:100%;border:0" @click="loginIn()" :loading="loading1">
                                <i class="el-icon-login" />
                                {{ $t('login.login') }}
                            </el-button>
                        </div>
                    </div>
                    <div class="plane_2">
                        <!-- 小按钮 -->
                        <div class="but_2">
                            <el-button type="info" text @click="this.$router.push('/register');">{{ $t('login.register')
                            }}</el-button>
                            <span>|</span>
                            <el-button type="info" text @click="forgetPassword()">{{ $t('login.forget') }}</el-button>
                        </div>
                        <div class="but_2">
                            <el-dropdown trigger="click">
                                <el-button type="primary" size="small" style="font-weight: 600;">
                                    {{ $t("header.language") }}
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item @click="changelanguage('English')">English</el-dropdown-item>
                                        <!-- <el-dropdown-item @click="changelanguage('chinese')">简体中文</el-dropdown-item> -->
                                        <el-dropdown-item
                                            @click="changelanguage('Portuguese')">Portuguese</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { loginApi, getCodeImg } from '@/utils/api'
import { ElNotification } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex';
export default {
    setup() {
        const { locale, t } = useI18n()
        const store = useStore();
        let changelanguage = (lang) => {
            if (lang === 'chinese') {
                locale.value = 'zh'
                sessionStorage.setItem('lang', 'zh')
            } else if (lang === 'English') {
                locale.value = 'en'
                sessionStorage.setItem('lang', 'en')
            } else {
                locale.value = 'por'
                sessionStorage.setItem('lang', 'por')
            }

        }
        //监视属性
        return { locale, changelanguage, t, store }
    },
    data() {
        return {
            login: {
                email: '',
                pass: '',
                code: '',
            },
            codeImg: '',
            codeID: '',
            loading1: false,
        }
    },
    methods: {
        loginIn() {
            this.loading1 = true;
            if (this.login.email === '' || this.login.pass === '' || this.login.code === '') {
                this.loading1 = false;
                return ElNotification({
                    title: 'error',
                    message: this.t('prompt.all_not_empty'),
                    type: 'error',
                })
            }
            let emailRE = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;//eslint-disable-line
            let isemail = emailRE.test(this.login.email);
            if (isemail === false) {
                return ElNotification({
                    title: this.t('prompt.Mistake'),
                    message: this.t('prompt.email_err'),
                    type: 'error',
                })
            }
            let param = {
                email: this.login.email,
                password: this.login.pass,
                imgCode: this.login.code,
                imgId: this.codeID
            }
            loginApi(param).then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.loading1 = false;
                        localStorage.setItem('token', res.headers.authorization);
                        sessionStorage.setItem('email', res.data.data.user);
                        this.store.commit('updateActiveName', 'aside.dash_board');
                        this.store.commit('updateActivePath', '/pannel');

                        this.$router.push('/home');

                    } else {
                        this.loading1 = false;
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            });

        },
        changeCode() {
            //获取图片验证码
            getCodeImg().then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        this.codeImg = res.data.data.imgDat;
                        this.codeID = res.data.data.imgId;

                    } else {
                        return ElNotification({
                            title: this.t('prompt.Mistake'),
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                } else {
                    return ElNotification({
                        title: 'Error',
                        message: 'Network error',
                        type: 'error',
                    })
                }
            })
        },
        //忘记密码
        forgetPassword() {
            this.$router.push('/forgetPasswords');
        }
    },
    created() {
        let token = localStorage.getItem('token');
        if (token !== null && token !== undefined) {
            loginApi().then(res => {
                if (res !== undefined) {
                    if (res.data.code === 0) {
                        sessionStorage.setItem('email', res.data.data.user);
                        this.store.commit('updateActiveName', 'aside.dash_board');
                        this.store.commit('updateActivePath', '/pannel');
                        this.$router.push('/home');

                    } else {
                        this.changeCode();
                    }
                }
            }).catch(() => {
                this.changeCode();
            });
        } else {
            this.changeCode();
        }
    }
}
</script>

<style scoped>
/* 图片变成图标 */
::v-deep .el-icon-login {
    background: url('../assets/img/login.png') center no-repeat;
    font-size: 15px;
    margin-right: 8px;
    width: 20px;
    font-weight: 700;
    background-size: cover;
}

::v-deep .el-icon-login:before {
    content: "替";
    font-size: 15px;
    margin-right: 8px;
    width: 20px;
    font-weight: 700;
    visibility: hidden;
}

::v-deep .el-icon-ball {
    background: url('../assets/img/ball.png') center no-repeat;
    display: inline-table;
    background-size: cover;
    width: 20px;
    font-size: 10px;
    height: 20px;
    margin-right: 5px;
}

::v-deep .el-icon-ball:before {
    content: "替";
    display: inline-table;
    background-size: cover;
    width: 20px;
    font-size: 10px;
    height: 20px;
    visibility: hidden;
}

.login {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-color: #e8eaf2;
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
}

.felx {
    display: flex;
    align-items: center;
}

.login_main {
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    overflow-y: auto;
}

.login_plane {
    max-width: 450px;
    width: 100%;
    margin: auto;
    background-color: white;
}

.plane {
    box-shadow: rgba(0, 0, 0, 0.05) 0 0.5rem 2rem;

}

.plane_1 {
    transition: opacity .25s ease-out;
    /* width: 100%; */
    margin: 0 auto;
    padding: 1.25rem;
    overflow-x: visible;
}

.title {
    text-align: center;
    margin-bottom: 1rem;
}

.input {
    margin-bottom: 1.25rem;
    display: block;
    height: calc(1.5em + 0.75rem + 7px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
}

.title_1 {
    font-size: 2.25rem;
    color: #343a40;
    font-weight: 700;
}

.title_2 {
    color: #6c757d !important;
    font-size: .875rem !important;
}

.plane_2 {
    color: #6c757d !important;
    background-color: #f8f9fa !important;
    padding: 1rem;
    display: flex;
    align-content: center;
    justify-content: space-between;
}

.but_1 {
    padding: 0.375rem 0.75rem;

}

.but_2 {
    font-size: .875rem !important;
}
</style>